import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

Vue.use(Router);

export default new Router({
  // mode:'history',
  routes: [{
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      beforeEnter: (to, from, next) => {
        let isLogin = localStorage.getItem('isLogin');
        if (isLogin) {
          next();
        } else {
          next({
            path: '/login',
            query: {
              Rurl: to.fullPath
            }
          }); //未登录则跳转到登陆界面，query:{ Rurl: to.fullPath}表示把当前路由信息传递过去方便登录后跳转回来
        }
      },
      children: [{
          path: '/',
          component: resolve => require(['../components/pages/dashboard/Dashboard.vue'], resolve)
        },
        { //支付通道管理
          path: '/channel',
          component: resolve => require(['../components/pages/branch/channel/BranchMgr.vue'], resolve)
        },
        { //通道交易名称管理
          path: '/tradeName',
          component: resolve => require(['../components/pages/branch/tradeName/TradeNameMgr.vue'], resolve)
        },
        { // 终端管理 -- 厂商管理
          path: '/factorymgr',
          component: resolve => require(['../components/pages/terminal/factorymgr/FactoryMgr.vue'], resolve)
        },
        { // 终端管理 -- 机型管理
          path: '/modelmgr',
          component: resolve => require(['../components/pages/terminal/modelmgr/ModelMgr.vue'], resolve)
        },
        { // 终端管理 -- 品号管理
          path: '/articleNo',
          component: resolve => require(['../components/pages/terminal/articalno/articalno.vue'], resolve)
        },
        { // 终端管理 -- 库存管理
          path: '/stockmgr',
          component: resolve => require(['../components/pages/terminal/stockmgr/StockMgr.vue'], resolve)
        },
        { // 终端管理 -- 撤机记录
          path: '/revoke',
          component: resolve => require(['../components/pages/terminal/revoke/revokemgr.vue'], resolve)
        },
        { // 终端管理 -- 黑名单
          path: '/blacklist',
          component: resolve => require(['../components/pages/terminal/blacklist/blackmgr.vue'], resolve)
        },
        { // 终端管理 -- 销售明细
          path: '/salemgr',
          component: resolve => require(['../components/pages/terminal/salemgr/SaleDetail.vue'], resolve)
        },
        //新增
        { //终端管理--初始化密码管理
          path: '/passmgr',
          component: resolve => require(['../components/pages/terminal/passmgr/PassMgr.vue'], resolve)
        },
        //新增
        { //终端管理--硬件信息
          path: '/hardwaremgr',
          component: resolve => require(['../components/pages/terminal/hardwaremgr/SaleDetail.vue'], resolve)
        },
        { //终端管理--硬件信息
          path: '/Speakersbind',
          component: resolve => require(['../components/pages/terminal/Speakersbind/bindMgr.vue'], resolve)
        },
        {
          path: '/appmgr', // 程序管理 -- 应用管理
          component: resolve => require(['../components/pages/program/appmgr/AppMgr.vue'], resolve)
        },
        {
          path: '/markmgr', // 程序管理 -- 应用标识管理
          component: resolve => require(['../components/pages/program/markmgr/MarkMgr.vue'], resolve)
        },
        {
          path: '/ossmgr', // 程序管理 -- OSS管理
          component: resolve => require(['../components/pages/program/ossmgr/OssMgr.vue'], resolve)
        },
        {
          path: '/pointManage', // TMS管理 -- 节点管理
          component: resolve => require(['../components/pages/tms/pointmgr/PointMgr.vue'], resolve)
        },
        {
          path: '/plansManage', // TMS管理 -- 计划管理
          component: resolve => require(['../components/pages/tms/plansmgr/PlansMgr'], resolve)
        },
        {
          path: '/termfile', // TMS管理 -- 终端文件上送
          component: resolve => require(['../components/pages/tms/termfile/TermfileMgr'], resolve)
        },
        {
          path: '/taskManage', // TMS管理 -- 任务管理
          component: resolve => require(['../components/pages/tms/taskmgr/taskMgr.vue'], resolve)
        },
        //新增---全局任务
        {
          path: '/globaltask', // 系统管理 -- 全局任务
          component: resolve => require(['../components/pages/tms/globaltask/globaltask.vue'], resolve)
        },
        {
          path: '/taskProgress', // TMS管理 -- 任务进度查询
          component: resolve => require(['../components/pages/tms/taskprogress/TaskProgressMgr.vue'], resolve)
        },
        {
          path: '/taskHistory', // TMS管理 -- 任务历史进度查询
          component: resolve => require(['../components/pages/tms/taskhistory/TaskHistoryMgr.vue'], resolve)
        },
        {
          path: '/logQuery', // TMS管理 -- 日志查询
          component: resolve => require(['../components/pages/tms/logquerymgr/LogQueryMgr.vue'], resolve)
        },
        {
          path: '/termlog', // TMS管理 -- 日志查询
          component: resolve => require(['../components/pages/tms/termlogmgr/TermLogMgr.vue'], resolve)
        },
        {
          path: '/installreport', // 交易管理 -- 装机报表
          component: resolve => require(['../components/pages/reports/installreport/InstallReport.vue'], resolve)
        },
        {
          path: '/tradelogmgr', // 交易管理 -- 交易日志报表
          component: resolve => require(['../components/pages/reports/tradelogmgr/TradeLogMgr.vue'], resolve)
        },
        {
          path: '/tradeflowmgr', // 交易管理 -- 交易流水报表
          component: resolve => require(['../components/pages/reports/tradeflowmgr/TradeFlowMgr.vue'], resolve)
        },
        {
          path: '/iotreport', // 交易管理 -- iot消息报表
          component: resolve => require(['../components/pages/reports/iotreport/IotReport.vue'], resolve)
        },
        {
          path: '/keymgr', // 密钥管理
          component: resolve => require(['../components/pages/keymgr/KeyMgr.vue'], resolve)
        },
        {
          path: '/sysuser', // 系统管理 -- 用户管理
          component: resolve => require(['../components/pages/sysmgr/usermgr/UserMgr.vue'], resolve)
        },
        {
          path: '/sysrole', // 系统管理 -- 角色管理
          component: resolve => require(['../components/pages/sysmgr/rolemgr/RoleMgr.vue'], resolve)
        },
        {
          path: '/sysauth', // 系统管理 -- 权限管理
          component: resolve => require(['../components/pages/sysmgr/authmgr/AuthMgr.vue'], resolve)
        },
        {
          path: '/sysmenu', // 系统管理 -- 菜单管理
          component: resolve => require(['../components/pages/sysmgr/menumgr/MenuMgr.vue'], resolve)
        },
        {
          path: '/sysfunc', // 系统管理 -- 功能管理
          component: resolve => require(['../components/pages/sysmgr/funcmgr/FuncMgr.vue'], resolve)
        },
        {
          path: '/sysorg', // 系统管理 -- 机构管理
          component: resolve => require(['../components/pages/sysmgr/orgmgr/orgMgr.vue'], resolve)
        },
        {
          path: '/sysrolemodel', // 系统管理 -- 角色模板管理
          component: resolve => require(['../components/pages/sysmgr/rolemodelmgr/RoleModelMgr.vue'], resolve)
        },
        {
          path: '/syslog', // 系统管理 -- 日志管理
          component: resolve => require(['../components/pages/sysmgr/logmgr/LogMgr.vue'], resolve)
        },
        {
          path: '/doc',
          name: 'doc',
          component: resolve => require(['../components/pages/doc/doc.vue'], resolve)
        },
        //系统参数管理
        {
          path: '/sysparam',
          name: 'sysparam',
          component: resolve => require(['../components/pages/sysmgr/parammgr/ParamMgr.vue'], resolve)
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['../components/pages/login/Login.vue'], resolve)
    }, {
      path: '/doc2',
      name: 'doc',
      component: resolve => require(['../components/pages/doc/doc.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js